<template src="./all.html"></template>

<script>
import { PersonApi } from '@chirhos/chirhos-api'
import { ChiRhosNext } from '@paladin/core'
import ModulesConfig from '@modules-config'
import axios from 'axios'

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
  page() {
    return {
      title: 'Person Search',
    }
  },
  components: { },
  props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
      people: [],
      totalRows: 0,
      loading: false,
      },
      query: '',
      page: 1,
      pageSize: 10,
      config: null,
    }
  },
  mounted: function() {

      var authHeader = 'Bearer ' + this.$store.state.auth.identity.accessToken
      axios.defaults.headers.common.Authorization = authHeader

      this.$nextTick(function() {
      this.config = ModulesConfig.tenants.find(function (tenant) {
          if (tenant) return tenant.hosts.includes(location.host)
      })
    })
  },
  methods: {
    search(page)
    {
      if(this.query)
      {
        this.data.loading = true

        if(page === 0)
        {
          this.data.people = []
          this.data.totalRows = 0
        }

        let data = this.data
        //let setProfileImage = this.setProfileImage

       ChiRhosNextApi.PersonApi.lookup({
        query: this.query,
        page: page
          }).then(
            response => {
              data.loading = false
              if (response.data) {
                response.data.forEach((value) => {
                    value.profileImage = { entityId: value.profileImage, data: '' }
                    this.setProfileImage(value)})

                data.people = response.data
                data.totalRows = response.totalCount
              }
            },
            error => {
              data.loading = false
              console.error(error);
              error.json().then(body => {
                this.$toast(body.Message, "error");
              })
            }
          )
      }
    },
    setProfileImage(item)
    {
      if(item.profileImage.entityId !== '00000000-0000-0000-0000-000000000000')
      {
        var url = this.config.chirhos.apiUrl;

        if(!url.endsWith('/')) url += '/'
        url += 'api/person/resource/'

        if(!item.profileImageFilename)
        {
          url = url + item.profileImage.entityId
        }
        else
        {
          url = url + item.profileImage.entityId + '/' + item.profileImageFilename
        }

        let person = item

        axios({
          method: 'get',
          url: url,
          responseType: 'arraybuffer'
        })
        .then(function(resp) {
          var mimeType = resp.headers['content-type'].toLowerCase()
          var imgBase64 = new Buffer(resp.data, 'binary').toString('base64')
          person.profileImage.data = 'data:' + mimeType + ';base64,' + imgBase64
        })
        }
    },
  },
}
</script>
